let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4NHao")).then(() => parcelRequire('hNn1a'));